import { noop } from 'lodash'
import { SvgQueueEdit, SvgReview } from '../assets/images'
import { SvgUnAssigned } from '../icons'
import Tooltip from './Tooltip'

const DYNAMIC_QUEUE_CONSTANTS = {
  ASSIGN_TO_ME: 'Assign to me',
  UNASSIGN: 'Unassign',
}

const DYNAMIC_QUEUE_MESSAGES = {
  UNASSIGN_TOOLTIP_MESSAGE: 'Unassign',
  REVIEW_TOOLTIP_MESSAGE: 'Review',
  EDIT: 'Edit',
  REVIEW: 'Review',
}

export const Unassigned = ({
  handleClick,
  isDisabled,
}: {
  handleClick: () => void
  isDisabled?: boolean
}) => {
  return (
    <Tooltip
      content={DYNAMIC_QUEUE_MESSAGES.UNASSIGN_TOOLTIP_MESSAGE}
      position="top"
    >
      <div
        onClick={isDisabled ? noop : handleClick}
        className={`${isDisabled ? 'cursor-not-allowed opacity-20' : ''}`}
        role="button"
        onKeyDown={(e) => {
          if ((e?.key === 'Enter' || e?.key === ' ') && !isDisabled) {
            handleClick()
          }
        }}
        tabIndex={0}
      >
        <SvgUnAssigned />
      </div>
    </Tooltip>
  )
}
export const Assigned = ({
  handleClick,
  isDisabled,
}: {
  handleClick: () => void
  isDisabled?: boolean
}) => {
  return (
    <div
      onClick={isDisabled ? noop : handleClick}
      className={`px-3 font-light text-xs w-[9rem] h-[1.75rem] flex justify-center gap-2 rounded items-center text-center border border-primary-500 hover:bg-primary-100 ${
        isDisabled ? 'cursor-not-allowed opacity-20' : ''
      }`}
      role="button"
      onKeyDown={(e) => {
        if ((e?.key === 'Enter' || e?.key === ' ') && !isDisabled) {
          handleClick()
        }
      }}
      tabIndex={0}
    >
      <div>{DYNAMIC_QUEUE_CONSTANTS.ASSIGN_TO_ME}</div>
    </div>
  )
}
export const ShowEditableIcon = ({
  handleClick,
  isDisabled,
}: {
  handleClick: () => void
  isDisabled: boolean
}) => {
  return (
    <Tooltip content={DYNAMIC_QUEUE_MESSAGES.REVIEW} position="top">
      <button
        onClick={isDisabled ? noop : handleClick}
        className={`${isDisabled ? 'cursor-not-allowed opacity-20' : ''}`}
      >
        <SvgQueueEdit />
      </button>
    </Tooltip>
  )
}
export const ShowReviewIcon = ({
  handleClick,
}: {
  handleClick: () => void
}) => {
  return (
    <Tooltip
      content={DYNAMIC_QUEUE_MESSAGES.REVIEW_TOOLTIP_MESSAGE}
      position="top"
    >
      <button onClick={handleClick}>
        <SvgReview />
      </button>
    </Tooltip>
  )
}
